import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

export class PointHistoryAdminForm extends FormBase {
    public panel: HTMLElement;

    public constructor(panel: HTMLElement) {
        super();
        this.panel = panel;
    }

    public getPanel(): HTMLElement {
        return this.panel;
    }

    public isInitialized(): boolean {
        return this.panel.dataset.pointHistoryAdminInitialized === "1";
    }

    public markInitialized(): void {
        this.panel.dataset.pointHistoryAdminInitialized = "1";
    }

    public getOpenButton(root: ParentNode = this.panel): HTMLButtonElement | null {
        return this.queryElement(root, `[data-role="${Roles.OPEN_POINT_HISTORY_ADJUST_MODAL}"]`, HTMLButtonElement);
    }

    public getModal(root: ParentNode = this.panel): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POINT_HISTORY_ADJUST_MODAL}"]`, HTMLElement);
    }

    public getOverlay(root: ParentNode = this.panel): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.POINT_HISTORY_ADJUST_MODAL_OVERLAY}"]`, HTMLElement);
    }

    public getForm(root: ParentNode = this.panel): HTMLFormElement | null {
        return this.queryElement(root, `[data-role="${Roles.POINT_HISTORY_ADJUST_FORM}"]`, HTMLFormElement);
    }

    public getModeInput(): HTMLInputElement | null {
        return this.queryElement(this.panel, `[data-role="${Roles.POINT_HISTORY_ADJUST_MODE}"]`, HTMLInputElement);
    }

    public getHistoryIdInput(): HTMLInputElement | null {
        return this.queryElement(
            this.panel,
            `[data-role="${Roles.POINT_HISTORY_ADJUST_HISTORY_ID}"]`,
            HTMLInputElement,
        );
    }

    public getAmountInput(): HTMLInputElement | null {
        return this.queryElement(
            this.panel,
            `[data-role="${Roles.POINT_HISTORY_ADJUST_AMOUNT_INPUT}"]`,
            HTMLInputElement,
        );
    }

    public getRuleSelectField(): HTMLElement | null {
        return this.queryElement(this.panel, `[data-role="${Roles.POINT_HISTORY_ADJUST_RULE_FIELD}"]`, HTMLElement);
    }

    public getRuleTypeInputs(): HTMLInputElement[] {
        return this.queryElements(this.panel, 'input[name="rule_type"]', HTMLInputElement);
    }

    public getRulePicker(): HTMLElement | null {
        return this.queryElement(this.panel, `[data-role="${Roles.POINT_HISTORY_ADJUST_RULE_PICKER}"]`, HTMLElement);
    }

    public getRuleReadonlyInput(): HTMLInputElement | null {
        return this.queryElement(
            this.panel,
            `[data-role="${Roles.POINT_HISTORY_ADJUST_RULE_READONLY}"]`,
            HTMLInputElement,
        );
    }

    public getCheckedRuleTypeInput(): HTMLInputElement | null {
        return this.queryElement(this.panel, 'input[name="rule_type"]:checked', HTMLInputElement);
    }

    public getNoteInput(): HTMLInputElement | HTMLTextAreaElement | null {
        return (
            this.queryElement(this.panel, `[data-role="${Roles.POINT_HISTORY_ADJUST_NOTE_INPUT}"]`, HTMLInputElement) ||
            this.queryElement(this.panel, `[data-role="${Roles.POINT_HISTORY_ADJUST_NOTE_INPUT}"]`, HTMLTextAreaElement)
        );
    }

    public getSubmitButton(): HTMLButtonElement | null {
        return this.queryElement(this.panel, `[data-role="${Roles.POINT_HISTORY_ADJUST_SUBMIT}"]`, HTMLButtonElement);
    }

    public getAmountField(): Element | null {
        const amountInput = this.getAmountInput();
        return amountInput instanceof HTMLInputElement
            ? this.closest(amountInput, ".point-history-adjust-form__field", HTMLElement)
            : null;
    }

    public getAmountLabel(): HTMLElement | null {
        return this.queryElement(this.panel, `[data-role="${Roles.POINT_HISTORY_ADJUST_AMOUNT_LABEL}"]`, HTMLElement);
    }

    public getRuleLabel(): HTMLElement | null {
        const field = this.getRuleSelectField();
        return field instanceof HTMLElement ? this.queryElement(field, ".form-label", HTMLElement) : null;
    }

    public getTitle(): HTMLElement | null {
        return this.queryElement(this.panel, "#point-history-adjust-title", HTMLElement);
    }

    public getCloseButtons(root: ParentNode = this.panel): HTMLElement[] {
        return this.queryElements(root, `[data-role="${Roles.CLOSE_POINT_HISTORY_ADJUST_MODAL}"]`, HTMLElement);
    }

    public getInvalidateButton(root: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(root, `[data-role="${Roles.POINT_HISTORY_INVALIDATE_BUTTON}"]`, HTMLButtonElement);
    }
}
